import navigatorLanguages from "navigator-languages";
import formatBcp47 from "format-bcp-47";
import appConfig from "@/appConfig";
import "@fixtures/modernizr";

function buildKey(prefix, key) {
  return prefix ? [prefix, key].join(".") : key;
}

function collectFailedModernizrTests(tests, prefix) {
  return Object.keys(tests).reduce((acc, key) => {
    const value = tests[key];
    if (Object.prototype.toString.call(value) === "[object Object]")
      return [
        ...acc,
        ...collectFailedModernizrTests(value, buildKey(prefix, key)),
      ];
    if (!value) return [...acc, buildKey(prefix, key)];
    return acc;
  }, []);
}

export function unsupportedBrowserFeatures() {
  return collectFailedModernizrTests(window.Modernizr);
}

export function getBrowserLocale() {
  return (
    navigatorLanguages()
      .map(formatBcp47)
      .map((bcp47) => bcp47.substr(0, 2))
      .find((locale) => appConfig.supportedLocales.includes(locale)) ||
    appConfig.defaultLocale
  );
}
